// Copyright 2022 - 2023 Fewcha. All rights reserved.

import { createAction, createAsyncThunk, createReducer } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "../../app/store";

import { ConfigReducer, defaultConfigReducer } from "./types";

export const getConfig = createAsyncThunk("config/getConfig", async (_) => {
  const res = await axios.get<ConfigReducer>(defaultConfigReducer.base.CONFIG_URL, {
    headers: { "Cache-Control": "no-cache" },
  });

  return res.data;
});

export const updateConfig = createAction<{ key: string; value: any }>("config/updateConfig");

const configReducer = createReducer(defaultConfigReducer, (builder) =>
  builder
    .addCase(getConfig.fulfilled, (_, action) => {
      return action.payload;
    })
    .addCase(updateConfig, (state, action) => {
      (state as any)[action.payload.key as any] = action.payload.value as any;
    }),
);

export const selectConfig = (state: RootState) => state.config;

export default configReducer;
